webpackJsonp([0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1);
	
	var _common = __webpack_require__(2);
	
	/* eslint-disable */
	var req = __webpack_require__(46);
	req.keys().forEach(function (key) {
		req(key);
	});
	/* eslint-enable */
	
	/**
	 * sprout member API
	 * Append each member block
	 */
	fetch('https://lab.25sprout.com/avatar/apo/25sproutMemberList.php').then(function (response) {
		return response.json();
	}).then(function (_ref) {
		var staffs = _ref.staffs;
	
		Object.keys(staffs).forEach(function (key) {
			document.querySelector('.member-wrapper').appendChild(document.querySelector('.member-block:first-child').cloneNode(true));
	
			var memberBlock = document.querySelector('.member-block:last-child');
			memberBlock.children[0].setAttribute('src', staffs[key].pic.large);
			memberBlock.children[1].innerText = staffs[key].name;
			memberBlock.children[2].innerText = staffs[key].title.join(' / ');
		});
	});
	
	window.onload = function () {
		(0, _common.windowOnLoad)();
	
		var bodyHeight = document.body.offsetHeight;
		var quoteHeight = window.innerHeight + document.querySelector('.quote-block').offsetHeight / 2;
		var itemAnimated = false;
	
		window.addEventListener('scroll', function (e) {
			var ratio = e.currentTarget.pageYOffset / bodyHeight;
	
			/**
	   * parallax
	   */
			document.querySelector('.content-section.-about').setAttribute('style', 'background-position: ' + 100 * (1 - ratio) + '% 50%');
	
			document.querySelector('.content-section.-about > .company-name').setAttribute('style', 'left: -' + Math.floor(1300 * ratio) + 'px');
	
			/**
	   * four quote fade in from left and right
	   */
			if (itemAnimated === false && e.currentTarget.pageYOffset >= quoteHeight) {
				itemAnimated = true;
	
				document.querySelectorAll('.way-item.-first')[0].className += ' fadeInLeft';
				document.querySelectorAll('.way-item.-first')[1].className += ' fadeInRight';
	
				setTimeout(function () {
					document.querySelectorAll('.way-item.-second')[0].className += ' fadeInLeft';
					document.querySelectorAll('.way-item.-second')[1].className += ' fadeInRight';
				}, 500);
			}
		});
	};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./about-content.css": 47,
		"./cfo-mark.css": 49,
		"./member-wrapper.css": 51,
		"./meow-text.css": 53,
		"./quote-block.css": 55,
		"./way-item.css": 57
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 46;


/***/ }),

/***/ 47:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 49:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// about.chunk.js